import { Lexer } from 'marked';

// 참조형 링크·각주 정의는 다른 블록에서 쓰이므로 이런 답변은 나누지 않고 통째로 그린다.
const DEFINITION_RE = /^ {0,3}\[[^\]\n]+\]:\s*\S/m;
const FENCE_LINE_RE = /^ {0,3}(`{3,}|~{3,})/gm;

const countMatches = (text, re) => (text.match(re) || []).length;

// 코드 펜스나 $$ 수식이 블록 경계를 넘으면 다음 블록과 합친다. 합치는 것은 언제나 안전하다.
const isClosed = (text) => (
  countMatches(text, FENCE_LINE_RE) % 2 === 0
  && countMatches(text, /\$\$/g) % 2 === 0
);

/**
 * 마크다운을 최상위 블록(문단·목록·표·코드…) 단위 원문 조각으로 나눈다.
 * 조각을 이어 붙이면 원문과 같다. 스트리밍 중에는 마지막 조각만 바뀌므로 앞 조각은 다시 파싱하지 않는다.
 */
export const splitMarkdownBlocks = (markdown) => {
  if (!markdown) return [];
  if (DEFINITION_RE.test(markdown)) return [markdown];

  let tokens;
  try {
    tokens = new Lexer({ gfm: true }).lex(markdown);
  } catch (error) {
    return [markdown];
  }

  const blocks = [];
  let current = '';
  tokens.forEach((token) => {
    current += token.raw || '';
    if (token.type === 'space') return;
    if (isClosed(current)) {
      blocks.push(current);
      current = '';
    }
  });
  if (current) {
    if (blocks.length > 0 && !current.trim()) {
      blocks[blocks.length - 1] += current;
    } else {
      blocks.push(current);
    }
  }
  return blocks.join('') === markdown.replace(/\r\n?/g, '\n') ? blocks : [markdown];
};

const stripInlineCode = (text) => text.replace(/`[^`\n]*`/g, '');

/**
 * 스트리밍 중 아직 닫히지 않은 마크다운 꼬리를 보정한다(마지막 블록에만 쓴다).
 * - 열린 **굵게**·`코드`를 임시로 닫고, 내용 없이 열린 기호는 지운다.
 * - 덜 써진 링크 `[글](주소` 는 글만 보인다.
 * - 마지막 줄의 `-`·`=` 한두 글자는 앞 문단을 잠깐 제목으로 바꾸므로 지운다.
 */
export const closeIncompleteMarkdown = (text) => {
  if (!text) return text;
  if (countMatches(text, FENCE_LINE_RE) % 2 === 1) return text;

  let out = text.replace(/\n[ \t]*[-=*+]{1,2}[ \t]*$/, '\n');
  out = out.replace(/\[([^\]\n]*)\]\([^)\s]*$/, '$1');

  const lastParagraph = out.slice(out.lastIndexOf('\n\n') + 1);
  const plain = stripInlineCode(lastParagraph);
  if (countMatches(plain, /`/g) % 2 === 1) {
    out = /`\s*$/.test(out) ? out.replace(/`\s*$/, '') : `${out}\``;
  }
  if (countMatches(plain, /\*\*/g) % 2 === 1) {
    out = /\*\*\s*$/.test(out) ? out.replace(/\*\*\s*$/, '') : `${out.replace(/\s+$/, '')}**`;
  }
  return out;
};
